/**
 * Card-related constants for Vision 360 feature
 */

/**
 * Number of days after which a card is considered outdated
 */
export const OUTDATED_THRESHOLD_DAYS = 30;

/**
 * Card status values
 */
export const CARD_STATUS = {
  UNAVAILABLE: 1,
  OCCUPIED: 4,
} as const;
